import { createAction, createAsyncAction } from 'app/helpers/action-helper';
import { getUserPreferences } from 'app/services/user-api-service';

export const actionTypes = {
  GET_CURRENT_USER: 'GET_CURRENT_USER',
  FETCH_USER: 'FETCH_USER',
  FETCH_USER_FULFILLED: 'FETCH_USER_FULFILLED',
};

export const getCurrentUser = (user) => createAction(actionTypes.GET_CURRENT_USER, user);

export const fetchUser = () => {
  return createAsyncAction(actionTypes.FETCH_USER, actionTypes.FETCH_USER_FULFILLED, async () => {
    const userPreferences = await getUserPreferences();

    return {
      userPreferences,
    };
  });
};
